import { parseXYAndKeepInfo } from 'xy-parser';
import { Analysis } from '../Analysis';
/**
 * Convert strings into JCAMP and add extra information
 * @param data - values to add to the file, usually a csv or tsv values
 * @param options
 */
export function fromText(data, options = {}) {
    const analysis = new Analysis();
    const { info = {}, parser = {} } = options;
    const parsed = parseXYAndKeepInfo(data, parser);
    const variables = {
        x: {
            data: parsed.data.x,
            units: info.xUnits || '',
            label: info.xLabel || '',
        },
        y: {
            data: parsed.data.y,
            units: info.yUnits || '',
            label: info.yLabel || '',
        },
    };
    analysis.pushSpectrum(variables);
    return analysis;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnJvbVRleHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZnJvbS9mcm9tVGV4dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsa0JBQWtCLEVBQWtCLE1BQU0sV0FBVyxDQUFDO0FBRS9ELE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxhQUFhLENBQUM7QUErQnZDOzs7O0dBSUc7QUFFSCxNQUFNLFVBQVUsUUFBUSxDQUN0QixJQUEwQixFQUMxQixVQUEyQixFQUFFO0lBRTdCLE1BQU0sUUFBUSxHQUFHLElBQUksUUFBUSxFQUFFLENBQUM7SUFFaEMsTUFBTSxFQUFFLElBQUksR0FBRyxFQUFFLEVBQUUsTUFBTSxHQUFHLEVBQUUsRUFBRSxHQUFHLE9BQU8sQ0FBQztJQUUzQyxNQUFNLE1BQU0sR0FBRyxrQkFBa0IsQ0FBQyxJQUFJLEVBQUUsTUFBTSxDQUFDLENBQUM7SUFDaEQsTUFBTSxTQUFTLEdBQTJCO1FBQ3hDLENBQUMsRUFBRTtZQUNELElBQUksRUFBRSxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUM7WUFDbkIsS0FBSyxFQUFFLElBQUksQ0FBQyxNQUFNLElBQUksRUFBRTtZQUN4QixLQUFLLEVBQUUsSUFBSSxDQUFDLE1BQU0sSUFBSSxFQUFFO1NBQ3pCO1FBQ0QsQ0FBQyxFQUFFO1lBQ0QsSUFBSSxFQUFFLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQztZQUNuQixLQUFLLEVBQUUsSUFBSSxDQUFDLE1BQU0sSUFBSSxFQUFFO1lBQ3hCLEtBQUssRUFBRSxJQUFJLENBQUMsTUFBTSxJQUFJLEVBQUU7U0FDekI7S0FDRixDQUFDO0lBRUYsUUFBUSxDQUFDLFlBQVksQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUVqQyxPQUFPLFFBQVEsQ0FBQztBQUNsQixDQUFDIn0=